import { Button } from "@/components/ui/button";
import { ExternalLink, Loader2 } from "lucide-react";

export default function CurrentPlanBanner({ plan, trialEnd, periodEnd, onPortal, managing, planKey }) {
  const details = [];
  if (plan?.status === "trialing" && trialEnd) details.push(`Trial ends ${trialEnd}`);
  if (plan?.status === "active" && periodEnd) details.push(`Next renewal ${periodEnd}`);
  if (plan?.cancel_at_period_end) details.push("cancels at period end");

  return (
    <div className="mt-6 space-y-3">
      <div className="p-3 rounded-xl bg-primary/10 text-sm">
        <div className="font-medium text-primary">Your current plan</div>
        <div className="text-stone-600 mt-1">{details.join(" — ")}</div>
      </div>
      <Button
        onClick={onPortal}
        disabled={managing}
        className="w-full rounded-full bg-primary text-primary-foreground"
        data-testid={`manage-billing-btn-${planKey}`}
      >
        {managing ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <ExternalLink className="w-4 h-4 mr-2" />}
        Manage billing
      </Button>
    </div>
  );
}
